import version from '../version';
import generateName from './generateName';
import roundValue from './roundValue';
var i, j;

const generateText = (state, options) => {
  var text = "";
  if(!options) options = {};

  if(state.decimal_places === undefined) state.decimal_places = 8;

  // text += ';revit metric.pat file\r\n';
  if(state.format === 'REVIT') text += ';%UNITS=' + state.units + '\r\n';
  if(state.format === 'REVIT') text += ';%VERSION=3.0\r\n';
  if(state.format === 'REVIT') text += ';\r\n';

  text += '*' + generateName(state) + '\r\n';
  if(state.description) text += ';' + state.description.replace(/\n+/g, ' ') + '\r\n';
  if(state.format === 'REVIT') text += ';%TYPE=' + state.type + '\r\n';
  text += ';\r\n';


  let spacer = ' ';
  if(state.text_alignment == "collapsed") spacer = '';

  const getLabelAt = index => {
    index = parseInt(index);

    var labels = [';angle', 'x', 'y', 'shift', 'offset', 'dash', 'space'];

    var retval = labels[index];
    if(!retval){
      var ni = (index - labels.length) % 2;
      retval = ['dash', 'space'][ni];
    }
    return retval;
  }

  var max_row_length = 7;
  for(var i in state.rows){
    if(state.rows[i].invisible && !options.includeHidden) continue;
    if(state.rows[i].cells.length > max_row_length) max_row_length = state.rows[i].cells.length;
  }

  var ln = [];
  var rv;
  for(j = 0; j < max_row_length; j++){
    var len = getLabelAt(j).length;

    for(i in state.rows){
      if(state.rows[i].invisible && !options.includeHidden) continue;
      rv = (roundValue(state.rows[i].cells[j], state.decimal_places) + "").length;
      if(rv > len){
        len = rv;
      }
    }
    ln.push(len);
  }

  var max_ln = ln.reduce(function(a, b) { return Math.max(a, b); }); 

  for(var i in ln){
    text += getLabelAt(i);

    if(i < ln.length - 1){
      text += ',';

      // for(var j = 0; j <= ln[i] - getLabelAt(i).length; j++){
      //   text += ' ';
      // }
      for(var k = 0; k < ((state.format !== 'AUTOCAD') ? max_ln : ln[i]) - getLabelAt(i).length; k++){
        text += spacer;
      }
      text += spacer;
    }
  }
  text += '\r\n';

  for(i = 0; i < state.rows.length; i++){
    // if(state.rows[i].invisible && !options.includeHidden) continue;
    var cell_length = state.rows[i].cells.length;
    // if(state.format === 'AUTOCAD' && cell_length > 11){
    //   cell_length = 11;
    // }

    var hasDashValue = false;
    for(var d = 5; d < cell_length; d++){
      if(state.rows[i].cells[d] !== 0 && !isNaN(state.rows[i].cells[d])  && state.rows[i].cells[d] !== '' && state.rows[i].cells[d] !== null && state.rows[i].cells[d] !== undefined){
        hasDashValue = true;
        break;
      }
    }
    if(!hasDashValue) cell_length = 5;

    for(j = 0; j < cell_length; j++){
      if(j >= 5 && (isNaN(state.rows[i].cells[j]) || state.rows[i].cells[j] === '' || state.rows[i].cells[j] === null || state.rows[i].cells[j] === undefined)) break;
        
      rv = roundValue(state.rows[i].cells[j], state.decimal_places)

      // Force spaces to be negative
      if(j >= 5 && (j - 5) % 2 == 1 && rv > 0) rv *= -1; 

      // Force dashes to be negative
      if(j >= 5 && (j - 5) % 2 == 0 && rv < 0) rv *= -1; 

      text += rv;
      

      if(j < cell_length - 1){
        if(j < 4 || (!isNaN(state.rows[i].cells[j + 1]) && state.rows[i].cells[j + 1] !== null && state.rows[i].cells[j + 1] !== "")){
          text += ',';
          for(var k = 0; k < ((state.format !== 'AUTOCAD') ? max_ln : ln[j]) - (rv + '').length; k++){
            text += spacer;
          }
          text += spacer;
        }
      }
    }
    if(i < state.rows.length - 1){
      text += '\r\n';
    }
  }

  text.trim();

  // if(state.rows.length > 0){
  //   text += '\r\n';
  // }

  if(state.format === 'AUTOCAD'){
    text += '\r\n'; 
  }

  return text;
}

export default generateText;


// WEBPACK FOOTER //
// ./src/pattern_utilities/generateText.js